import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from "mobx-react";
import {BreadcrumbsItem} from "./breadcrumbs.item";

class BreadcrumbsListProps extends BaseProps {}

export const BreadcrumbsList = observer(({controller, isCollapsed, onRenderComplete}: BreadcrumbsListProps) => {
  const {state} = controller
  const {breadcrumbsList} = state

  const items = isCollapsed ? breadcrumbsList.slice(1, -1) : breadcrumbsList;

  return (
    items.map((item, index) => <BreadcrumbsItem
      controller={controller}
      item={item}
      isLast={index === (items.length - 1)}
      isCollapsed={isCollapsed}
      key={index}
      onRenderComplete={onRenderComplete}
    />)
  )
});
